<div class="contact-container page-container">
  <div class="left-column">
    <div class="left-item-1"></div>
    <div class="left-item-2"></div>
  </div>
  <div class="right-column">
    <div class="right-item">
      <div
        id="map"
        style="height: 100%; width: 100%; border-radius: 20px"
      ></div>
      <!-- <div class="zoom">
        <p-button (click)="zoomIn()">+</p-button>
        <p-button (click)="zoomOut()">-</p-button>
      </div> -->
    </div>
  </div>
</div>
